exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-link[data-v-af06e15a] {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #0d1824;\n}\n", ""]);

// exports
